// ============================================================
// CarePlanRoleMappingsSection.jsx  (Care Coordinator, role-model expansion Push 2;
// refactored onto the shared ModuleRoleMappingsSection 2026-07-13)
//
// Thin instantiation of the shared component — no tier (single access level).
// PARITY CLOSE: via the shared component this section now GAINS the "Module
// role" dropdown + the MODULE ROLE table column it originally lacked (built
// with a single hardcoded value). Care Coordinator is the only option today;
// the dropdown is the extensible seam. Eligibility (carer + admin, §2.3) is
// enforced where the grant lands (JIT/reconcile).
// ============================================================

import React from 'react';
import ModuleRoleMappingsSection from './ModuleRoleMappingsSection';
import {
  listCarePlanRoleMappings,
  createCarePlanRoleMapping,
  deleteCarePlanRoleMapping,
} from '../api/federation';

const ROLE_LABEL = { care_coordinator: 'Care Coordinator' };

export default function CarePlanRoleMappingsSection({ clientId }) {
  return (
    <ModuleRoleMappingsSection
      clientId={clientId}
      testId="careplan-role-mappings"
      title="CarePlan role mappings"
      descriptor="Map an AD group to a CarePlan module role. Members (carer/admin core) are auto-granted on sign-in and the hourly reconcile."
      roleField="carePlanRole"
      roleOptions={[{ value: 'care_coordinator', label: 'Care Coordinator' }]}
      emptyMessage="No CarePlan role mappings configured yet."
      confirmTitle="Remove CarePlan role mapping?"
      confirmMessage={(t) => `Members of "${t.groupDisplayName || t.groupObjectId}" will lose this ${ROLE_LABEL[t.carePlanRole] || t.carePlanRole} mapping at the next reconcile. Existing grants are not removed immediately.`}
      toastCreated="CarePlan role mapping created."
      toastRemoved="CarePlan role mapping removed."
      api={{ list: listCarePlanRoleMappings, create: createCarePlanRoleMapping, remove: deleteCarePlanRoleMapping }}
    />
  );
}
